import React from "react";
import { Col, Row } from "reactstrap";
import { Select } from "@mantine/core";
import SummaryMapWidget from "./SummaryMapWidget";
import WeatherForecast from "../../../Establishment/Establishments/Summary/Widgets/WeatherForecast";
import WeatherForecastVariable from "../../../Establishment/Establishments/Summary/Widgets/WeatherForecastVariable";
import OPlaceholder from "../../../../Components/OElements/OPlaceholder";
import MicroalgaeConcentrationSummary from "../../../Establishment/Establishments/Summary/Widgets/MicroalgaeConcentrationSummary";

const MemoizedWidget = React.memo(
    ({
        WidgetComponent,
        title,
        um,
        code_siep,
        height,
        showHeader,
        showFooter,
        icon,
        h100,
    }) => (
        <WidgetComponent
            title={title}
            um={um}
            code_siep={code_siep}
            height={height}
            showHeader={showHeader}
            showFooter={showFooter}
            icon={icon}
            h100={h100}
        />
    )
);

function LoadingWrapper({ isLoading, children }) {
    return isLoading ? <OPlaceholder /> : children;
}



const RightPanel = ({
    selectedEstablishment,
    widgets,
    currentWidgetIndex,
    setCurrentWidgetIndex,
    codeSiep,
}) => {
    return (
        <React.Fragment>
            {selectedEstablishment && (
                <div className="overlay-widgets-map">
                    <Row className="g-2">
                        <Col xs={12} className="card-map-resize">
                            <SummaryMapWidget establishmentState={selectedEstablishment?.state} codeSiep={codeSiep}/>
                        </Col>
                        {/* <Col xs={12} className="card-map-resize">
                            <div style={{ position: "relative" }}>
                                <div className="action-right-panel" style={{ minWidth: 160 }}>
                                    <Select
                                        placeholder="Seleccionar gráfico"
                                        data={widgets.map((w, idx) => ({
                                            label: w.title,
                                            value: String(idx),
                                        }))}
                                        value={String(currentWidgetIndex)}
                                        onChange={(value) => {
                                            if (value !== null) setCurrentWidgetIndex(Number(value));
                                        }}
                                        size="xs"
                                        radius="lg"
                                        styles={{
                                            item: {
                                                "&[data-selected]": {
                                                    backgroundColor: "#0D1C36",
                                                    color: "#fff",
                                                },
                                                "&[data-hovered]": {
                                                    backgroundColor: "#0D1C36",
                                                    color: "#fff",
                                                },
                                                "&[data-selected][data-hovered]": {
                                                    backgroundColor: "#000E27",
                                                    color: "#fff",
                                                },
                                            },
                                        }}
                                    />
                                </div>
                                {widgets.map((widget, index) => {
                                    const WidgetComponent = widget.component;
                                    return (
                                        <div
                                            key={index}
                                            style={{
                                                display: currentWidgetIndex === index ? "block" : "none",
                                            }}
                                        >
                                            <MemoizedWidget
                                                WidgetComponent={WidgetComponent}
                                                title={widget.title}
                                                um={widget.um}
                                                code_siep={codeSiep}
                                                h100={false}
                                                icon={widget.icon}
                                                height={200}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </Col> */}
                        <Col xs={12} className="">
                            <MicroalgaeConcentrationSummary
                                title="Microalgas Nocivas Encontradas"
                                um="mg/L"
                                code_siep={codeSiep}
                                height={250}
                                showFooter={false}
                            />
                        </Col>
                        <Col xs={12} className="card-map-resize">
                            <LoadingWrapper>
                                <WeatherForecast code_siep={102082} lat={-42.4788} lon={-72.4357} />
                            </LoadingWrapper>
                        </Col>

                        <Col xs={12}>
                            <LoadingWrapper>
                                <WeatherForecastVariable
                                    code_siep={102082}
                                    lat={-42.4788}
                                    lon={-72.4357}
                                    className="rounded-4"
                                />
                            </LoadingWrapper>
                        </Col>
                    </Row>
                </div>
        )}
    </React.Fragment>
    );
};

export default RightPanel;
